import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as api from '../../api';
import PiechartComponent from '../../components/charts/piechart/PiechartComponent';
import DoughnutComponent from '../../components/charts/doughnut/DoughnutComponent';

import { Grid, Button } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { Helmet } from "react-helmet";
import WasteTableHeader from "./waste-table-header";
import WasteTableRow from "./waste-table-row";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";

function mapStateToProps(state) {
    return {

    };
}


class Waste extends Component {

    constructor(props){
        super(props);

        this.state = {
            dataProvider: new ApiDataProvider(api.getWasteList, [this.props.customerId, ""]),
            wasteContainer: [],
            wasteDestination: [],
            wasteStream:[]
        };
    }

    render() {
        let containerData = this.state.wasteContainer.map(function(item) {return item.count})
        let containerLabel = this.state.wasteContainer.map(function(item) {return item.container})
        return (
            <div className="main-container">
                <Helmet>
                    <title>Inenco Portal | Waste</title>
                </Helmet>
                <Grid padded stackable columns='equal' verticalAlign='middle'>
                    <Grid.Row>
                        <Grid.Column>
                            <h2>Waste</h2>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                        <PiechartComponent 
                                labels={['General Waste', 'Solid Hazardous', 'Mixed Recyclables']}
                                data={[88,16,149]}
                                title={"Waste Submission Count by Waste Stream"}
                                />
                        </Grid.Column>

                        <Grid.Column>
                            <DoughnutComponent 
                                labels={[ 'Materials Recovery Facility', 'Recycled']}
                                data={[124,327]}
                                title={"Waste Submission Count by Destination"}
                                />
                        {this.state.wasteContainer.length>0 && <PiechartComponent labels={containerLabel} data={containerData} title={"Waste Submission Count By Waste Container"}/>}
                        </Grid.Column>

                        <Grid.Column>
                         <PiechartComponent 
                                labels={['140L Container', 'Standard Black Sacks', '1100L Wheelie Bin']}
                                data={[12,202,366]}
                                title={"Waste Submission Count by Waste Container"}
                                />
                        {this.state.wasteContainer.length>0 && <PiechartComponent labels={containerLabel} data={containerData} title={"Waste Submission Count By Waste Container"}/>}
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            <h2>Waste List</h2>
                        </Grid.Column>
                        <Grid.Column>
                            <Button compact floated='right' id="log-waste">Log Waste</Button>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            <div className="table-container">
                                <FilterableDatatable dataProvider={this.state.dataProvider} name="waste" canExport={true}
                                                     headerComponent={WasteTableHeader} rowComponent={WasteTableRow}/>
                            </div>
                        </Grid.Column>
                    </Grid.Row>

                </Grid>
            </div>
        );
    }

    componentDidMount = () => {
        this.fetchData();
    }

    fetchData = () => {
        return Promise.all([
            api.getWasteSubmissionCountByContainer(this.props.customerId),
            api.getWasteSubmissionCountByDestination(this.props.customerId),
            api.getWasteSubmissionCountByStream(this.props.customerId),
          ])
          .then(([ wasteContainer, wasteDestination, wasteStream])=>
          this.setState({  wasteContainer, wasteDestination, wasteStream })
          )

    }
}

export default connect(
    mapStateToProps,
)(Waste);